export const getArrayLength = (value: unknown): number | undefined =>
  Array.isArray(value) ? value.length : undefined;

export const formatCountSummary = (
  count: number | undefined,
  singular: string,
  plural: string
): string => {
  if (count === undefined) {
    return `Review proposed ${plural}.`;
  }

  return `${count} ${count === 1 ? singular : plural} affected.`;
};
